module.exports = __webpack_public_path__ + "static/media/mycart_banner_ad.5c4830bd.png";